import getLeaveDisplayLabel from '../model-extensions/getLeaveDisplayLabel';
import calculateDateParameters from '../calculateDateParameters';
import extendUserModel from './extendUserModel';
import context from '../context';
import { formatDate, getDisplayDuration } from '../utils';
import gettext from '../lang/gettext';

export default function extendAvailabilityModel(model) {
  const result = { ...model };

  if (typeof result.dtstart === 'string') {
    Object.assign(result, calculateDateParameters(result));
  }

  result.user = extendUserModel(result.user);

  result.date = formatDate(result.dtstart);
  result.duration = (result.dtend - result.dtstart) / 1000 / 60 / 60;

  const durationInMinutes = result.duration * 60;
  const decimalFormat = context.getDecimalFormat();
  result.displayDuration = getDisplayDuration(durationInMinutes, decimalFormat);
  result.sort = -1;
  result.key = result.id;
  result.canBeSelected = false;

  if (!('displayLabel' in model)) {
    if (result.fullDay) {
      result.displayLabel = gettext('All day');
    } else {
      result.displayLabel = getLeaveDisplayLabel(result);
    }
  }
  result.monthBlockSecondRow = gettext('Unavailable');
  if (context.unavailabilityApproval && !result.approved) {
    result.monthBlockSecondRow += ` • ${gettext('Pending')}`;
  }
  result.auxDisplayLabel = result.monthBlockSecondRow;

  result.monthBlockThirdRow =
    context.me.isManager || context.usersCanSeeOtherSchedules ? result.user.fullname : '';

  result.shiftAppearance = {
    day: {
      firstLine: result.displayLabel,
      secondLine: result.auxDisplayLabel,
      timeSource: ['firstLine', 0],
    },
    week: {
      firstLine: result.displayLabel,
      secondLine: result.auxDisplayLabel,
      thirdLine: result.user.fullname,
      timeSource: ['firstLine', 0],
    },
    month: {
      firstLine: result.displayLabel,
      secondLine: result.monthBlockSecondRow,
      thirdLine: result.user.fullname,
      timeSource: ['firstLine', 0],
    },
  };

  return result;
}
